import { FC, ReactNode } from 'react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
interface TagRowProps extends BoxProps {
  children: ReactNode;
}
const TagRow: FC<TagRowProps> = ({
  children,
  ...rest
}) => <Box display="flex" flexWrap="wrap" justifyContent="left" {...rest} data-sentry-element="Box" data-sentry-component="TagRow" data-sentry-source-file="CbTagBox.tsx">
    {children}
  </Box>;
export interface CbTagBoxProps {
  tags: string[];
}
export const CbTagBox: FC<CbTagBoxProps> = ({
  tags
}) => {
  const possibleColors = ['venasaur.500', 'chonky.500', 'luigisPants.500', 'kirby.500', 'samus.500', 'cloud.500', 'venasaur.600', 'chonky.600', 'luigisPants.600', 'kirby.600', 'samus.600', 'cloud.600'];
  return <Box data-sentry-element="Box" data-sentry-component="CbTagBox" data-sentry-source-file="CbTagBox.tsx">
      <TagRow data-sentry-element="TagRow" data-sentry-source-file="CbTagBox.tsx">
        {tags?.map((filter, i) => {
        const tagColor = possibleColors[i];
        return <Flex key={i} alignItems="center" paddingX="8px" paddingY="2px" borderWidth="1px" borderRadius="8px" width="fit-content" borderColor={tagColor} marginRight={2} marginBottom={2}>
              <Text color={tagColor} fontSize="sm">
                {filter}
              </Text>
            </Flex>;
      })}
      </TagRow>
    </Box>;
};